import './tips.css';
import React, { useState } from 'react';
import TipsIcon from '@material-ui/icons/EmojiObjects';
import Button from 'components/Styled/Button/Button';

function Tips() {
    const [isOpen, setIsOpen] = useState(false);

    const onToggleClick = () => {
        setIsOpen(isOpen=>!isOpen);
    }

    return (
        <div 
            id='tips_mainContainer'
            style={{
                width: isOpen ? 300 : 0,
                height: isOpen ? 340 : 30,
            }}
        >
            <div id='tips_toggleContainer' onClick={onToggleClick}>
                <TipsIcon color='secondary' fontSize='large' />
            </div>
            <div 
                id='tips_content'
                style={{
                    opacity: isOpen ? 1 : 0,
                }}
            >
                <h3>Queleques questions à poser !</h3>
                <hr></hr>
                <ul>
                    <li>Quand tu as reçu la boîte, combien y avait-il de diamants ?</li>
                    <li>Quand tu as reçu la boîte, quels jetons personnages y avait-il ?</li>
                    <li>Quand tu as passé la boîte, que restait-il ?</li>
                    <li>Qu’as-tu pris ?</li>
                </ul>
                <a 
                    href='http://jeuxstrategie1.free.fr/jeu_mafia/regle.pdf' 
                    target='_blanc' 
                    rel="noreferrer"
                >
                    <Button color='secondary'>Les règles</Button>
                </a>
            </div>
        </div>
    )
}

export default Tips;
